var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Logs de Usuário" } },
    [
      _c(
        "sc-grid",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.currentLogsList,
            total: _vm.totalLogsUser,
            "default-sort-column": "action_time",
            "default-sort-direction": "desc",
            "has-backend-pagination": true,
            "has-backend-sorting": false,
            "default-filters": _vm.defaultFilters,
            rules: _vm.rules
          },
          on: { pagination: _vm.searchLogsUser, submit: _vm.searchLogsUser },
          scopedSlots: _vm._u([
            {
              key: "filters",
              fn: function(ref) {
                var filters = ref.filters
                return [
                  _c("sc-logs-user-filters", {
                    attrs: { filters: filters },
                    on: { "change-filters": _vm.changeFilters }
                  })
                ]
              }
            },
            {
              key: "filters-actions",
              fn: function(ref) {
                var isLoading = ref.isLoading
                var isValid = ref.isValid
                var filters = ref.filters
                return [
                  _c("sc-button", {
                    staticClass: "button is-primary",
                    attrs: {
                      loading: _vm.exportLoading,
                      disabled: _vm.exportDisabled(isValid),
                      text: "Exportar em Excel"
                    },
                    on: {
                      click: function($event) {
                        _vm.exportLogsUser({ filters: filters })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("sc-button", {
                    attrs: {
                      type: "submit",
                      theme: "primary",
                      text: "Buscar",
                      loading: isLoading
                    }
                  })
                ]
              }
            },
            {
              key: "table-columns",
              fn: function(ref) {
                var props = ref.props
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Date e hora",
                        field: "action_time",
                        width: "160",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.action_time) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Autor",
                        field: "author_email",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.author_email) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Ação", field: "action", sortable: "" } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.action) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { label: "Origem", field: "module", sortable: "" }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.module) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: { label: "Status", field: "status", sortable: "" }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.status) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "O que mudou?",
                        field: "what_has_changed",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.what_has_changed) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        label: "Identificador",
                        field: "identity_change",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.identity_change) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Ver mais" } },
                    [
                      _c(
                        "sc-button",
                        {
                          attrs: { theme: "primary" },
                          on: {
                            click: function() {
                              return _vm.openViewModal(props.row)
                            }
                          }
                        },
                        [_c("sc-icon", { attrs: { icon: "plus" } })],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    { attrs: { label: "Comparar", field: "isRowChecked" } },
                    [
                      _c("sc-checkbox", {
                        attrs: {
                          value: props.row.isRowChecked,
                          disabled: props.row.isRowDisabled
                        },
                        on: {
                          input: function(isRowChecked) {
                            return _vm.changeCheckRow(props.row, isRowChecked)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { attrs: { slot: "before-table" }, slot: "before-table" },
            [
              _c(
                "div",
                { staticClass: "buttons is-right" },
                [
                  _c(
                    "sc-tooltip",
                    {
                      attrs: {
                        label:
                          "Escolha dois registros e compare as diferenças campo a campo",
                        position: "is-left",
                        delay: 600,
                        multilined: ""
                      }
                    },
                    [
                      _c("sc-button", {
                        attrs: {
                          theme: "primary",
                          text: "Comparar detalhes",
                          disabled: _vm.diffDisabled
                        },
                        on: { click: _vm.openDiffModal }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "sc-modal",
        {
          attrs: { "has-modal-card": "", active: _vm.showViewUserLogModal },
          on: {
            "update:active": function($event) {
              _vm.showViewUserLogModal = $event
            }
          }
        },
        [
          _c(
            "sc-modal-card",
            [
              _c("template", { attrs: { slot: "title" }, slot: "title" }, [
                _c(
                  "h2",
                  { staticClass: "modal-card-title notification-title" },
                  [_vm._v("\n          Ver mais\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "div-modal" }, [
                  _vm.errorMessage
                    ? _c("div", { staticClass: "content" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v("Mensagem de erro: "),
                            _c("span", { staticClass: "has-text-danger" }, [
                              _vm._v(_vm._s(_vm.errorMessage))
                            ])
                          ])
                        ])
                      ])
                    : _c(
                        "div",
                        [
                          _c("div", { staticClass: "content" }, [
                            _c("p", { staticClass: "is-white" }, [
                              _vm._v(
                                "As linhas com fundo em branco indicam que não houve alterações."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "is-red" }, [
                              _vm._v("As linhas com o sinal de menos ("),
                              _c("span", { staticClass: "is-dark" }, [
                                _vm._v("-")
                              ]),
                              _vm._v(
                                ") e fundo em vermelho indicam como os dados eram antes de serem alterados."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "is-green" }, [
                              _vm._v("As linhas com o sinal de mais ("),
                              _c("span", { staticClass: "is-dark" }, [
                                _vm._v("+")
                              ]),
                              _vm._v(
                                ") e fundo em verde indicam como os dados ficaram após serem alterados."
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("sc-json-compare", {
                            attrs: {
                              oldData: _vm.userLogPayloadBefore,
                              newData: _vm.userLogPayloadAfter
                            }
                          })
                        ],
                        1
                      )
                ])
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-warning",
                    on: {
                      click: function($event) {
                        _vm.showViewUserLogModal = false
                      }
                    }
                  },
                  [_vm._v("Fechar")]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-modal",
        {
          attrs: { "has-modal-card": "", active: _vm.showCompareUserLogModal },
          on: {
            "update:active": function($event) {
              _vm.showCompareUserLogModal = $event
            }
          }
        },
        [
          _c(
            "sc-modal-card",
            [
              _c("template", { attrs: { slot: "title" }, slot: "title" }, [
                _c(
                  "h2",
                  { staticClass: "modal-card-title notification-title" },
                  [_vm._v("\n          Comparar detalhes\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "div-modal" },
                  [
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "is-white" }, [
                        _vm._v(
                          "As linhas com fundo em branco indicam que não houve alterações."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-red" }, [
                        _vm._v("As linhas com o sinal de menos ("),
                        _c("span", { staticClass: "is-dark" }, [_vm._v("-")]),
                        _vm._v(
                          ") e fundo em vermelho indicam como os dados eram antes de serem alterados."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-green" }, [
                        _vm._v("As linhas com o sinal de mais ("),
                        _c("span", { staticClass: "is-dark" }, [_vm._v("+")]),
                        _vm._v(
                          ") e fundo em verde indicam como os dados ficaram após serem alterados."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("sc-json-compare", {
                      attrs: {
                        oldData: _vm.oldUserLog,
                        newData: _vm.newUserLog
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-warning",
                    on: {
                      click: function($event) {
                        _vm.showCompareUserLogModal = false
                      }
                    }
                  },
                  [_vm._v("Fechar")]
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3899a06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3899a06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/PageLogsUser.vue
// module id = null
// module chunks = 